import { useState, useEffect } from "react";

const usePracticeHook = () => {
  const [userPractice, setUserPractice] = useState([]);

  useEffect(() => {
    const userClaims = JSON.parse(localStorage.getItem("user-claims"));
    if (userClaims && userClaims.practice) {
      setUserPractice(userClaims.practice);
    }
  }, []);

  const hasPractice = (name) => userPractice.some((data) => data.name === name);

  return {
    hasPhysioPractice: hasPractice("physiotherapist"),
    hasDiatecianPractice: hasPractice("diatetics"),
    hasSpeechPathologistPractice: hasPractice("speech_pathology"),
    hasGeneralPractice: hasPractice("general_practitioner"),
  };
};

export default usePracticeHook;